import React from "react";

import styled, { keyframes } from "styled-components";

const Jumbotron = () => {


  return (
    <JumboContainer>
      {/* Video Background */}
      <VideoBackground autoPlay loop muted playsInline>
        <source src="/jumbo.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </VideoBackground>

      {/* Transparent Overlay */}
      <Overlay />

      {/* Content */}
<Content>
  <Headline>
    <AnimatedElement $delay="0.5s">
      <h1>
        <Highlight>Natychmiastowe raporty, zero pracy z przygotowaniem danych</Highlight> <br />
      </h1>
    </AnimatedElement>

    <AnimatedElement $delay="0.7s">
      <p>Wykorzystaj comiesięczne pliki JPK i uzyskaj ponad 100 analiz i wykresów, sprawdź przyszłych i obecnych partnerów biznesowych.</p>
    </AnimatedElement>
  </Headline>

  <Actions>
    <AnimatedElement $delay="1.3s">
      <SecondaryButton href="/demo-login">Darmowe DEMO</SecondaryButton>
    </AnimatedElement>
    <AnimatedElement $delay="1.5s">
      <PrimaryButton href="/register-demo">Załóż pełne konto</PrimaryButton>
    </AnimatedElement>
  </Actions>
          <Features>
          <AnimatedElement $delay="2s">
            <Feature><span>✔</span> Wizualizuj kluczowe trendy w danych</Feature>
          </AnimatedElement>
          <AnimatedElement $delay="2s">
            <Feature><span>✔</span> Generuj raporty w czasie rzeczywistym</Feature>
          </AnimatedElement>
          <AnimatedElement $delay="2s">
            <Feature><span>✔</span> Podejmuj trafniejsze decyzje na podstawie danych</Feature>
          </AnimatedElement>
        </Features>
</Content>

    </JumboContainer>
  );
};


// Animation keyframes
const fadeInUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const AnimatedElement = styled.div`
  opacity: 0;
  animation: ${fadeInUp} 0.8s ease-out forwards;
  animation-delay: ${({ $delay }) => $delay || "0s"};
`;


// Styled Components
const JumboContainer = styled.div`
  position: relative;
  width: 100%;
  height: 50vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

    @media (max-width: 768px) {
    height: auto; /* Allow content to flow properly */
    padding-top: 2rem; /* Reduced padding to prevent cropping */
  }
`;

const VideoBackground = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6); /* Transparent dark overlay */
  z-index: 1;
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  width: 80%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    width: 90%;
    padding-bottom: 2rem; /* Add spacing at the bottom on small screens */
  }
`;
const Features = styled.div`
  margin-top: 5rem;
  display: flex;
  justify-content: center;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const Feature = styled.div`
  font-size: 1.2rem;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 0.7rem;

  span {
    color: #22c55e;
    font-weight: bold;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;


const Headline = styled.div`
  h1 {
    font-size: 3rem;
    line-height: 1.2;
    color: #fff;
    margin-bottom: 3rem;

    @media (max-width: 768px) {
      font-size: 2.2rem;
    }
  }

  p {
    font-size: 1.3rem;
    color: white;
    @media (max-width: 768px) {
      font-size: 1.1rem;
    }
  }
`;

const Highlight = styled.span`
  /* Fallback color */
  color: #3bc3cc;

  /* Gradient text */
  background: linear-gradient(90deg, #3bc3cc 0%, #ffffffff 50%, #3bc3cc 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;

  /* Optional: a tiny sheen animation—remove if you want static */
  background-size: 200% 100%;
  animation: gradientShift 4s ease infinite;

  @keyframes gradientShift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
`;



const Actions = styled.div`
  margin-top: 3rem;
  display: flex;
  justify-content: center;
  gap: 1.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 3rem; /* Increased gap for mobile */
    align-items: center;
    width: 100%;
  }
`;

const buttonPulse = keyframes`
  0% { transform: scale(1); box-shadow: 0 0 10px rgba(79, 70, 229, 0.3); }
  50% { transform: scale(1.05); box-shadow: 0 0 20px rgba(79, 70, 229, 0.5); }
  100% { transform: scale(1); box-shadow: 0 0 10px rgba(79, 70, 229, 0.3); }
`;


const secondaryButtonPulse = keyframes`
  0% { transform: scale(1); box-shadow: 0 0 10px rgba(0, 123, 255, 0.3); }
  50% { transform: scale(1.05); box-shadow: 0 0 20px rgba(0, 123, 255, 0.8); }
  100% { transform: scale(1); box-shadow: 0 0 10px rgba(0, 123, 255, 0.3); }
`;

const textPulse = keyframes`
  0% { color: #0d6efd; } /* Lighter Blue */
  50% { color: #007bff; } /* Neon Blue */
  100% { color: #0d6efd; } /* Back to Lighter Blue */
`;

const PrimaryButton = styled.a`
  background-color: #3bc3cc;
  color: #fff;
  padding: 1rem 2rem;
  border-radius: 30px;
  font-size: 1.2rem;
  font-weight: bold;
  text-decoration: none;
  transition: all 0.3s ease;
  animation: ${buttonPulse} 2s infinite;

  &:hover {
    background-color: black;
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    font-size: 1rem;
    padding: 0.8rem 1.5rem;
  }
`;

const SecondaryButton = styled.a`
  background-color: #f1f5f9;
  color: #1f2937;
  padding: 1rem 2rem;
  border-radius: 30px;
  font-size: 1.2rem;
  font-weight: bold;
  text-decoration: none;
  transition: all 0.3s ease;
  animation: ${secondaryButtonPulse} 2s infinite;

  span {
    animation: ${textPulse} 1.5s infinite alternate;
    font-weight: bold;
  }

  &:hover {
    background-color: #e2e8f0;
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    font-size: 1rem;
    padding: 0.8rem 1.5rem;
  }
`;


export default Jumbotron;
